import { ColumnWrapper, Description, Info, Title } from '../footer.style'

type ContactProps = {
    id?: string
}

export const Contact = ({ id }: ContactProps) => {
    return (
        <ColumnWrapper id={id}>
            <Title>Kapcsolat</Title>
            <Description>Bármilyen kérdés vagy probléma esetén keress minket a következő elérhetőségek valamelyikén:</Description>
            <Info>+36 30 074 3731</Info>
            <Info>marton.ticket@gmail.com</Info>
        </ColumnWrapper>
    )
}
